import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import {DeviceService} from '@app/core/services/device.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class NeedSyncInterceptor implements HttpInterceptor {

  constructor(private device: DeviceService) {}



  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {



    if (request.method.toLowerCase() !== 'post'
        && request.method.toLowerCase() !== 'delete'
        && request.method.toLowerCase() !== 'put'
        && request.method.toLowerCase() !== 'patch') {
      return next.handle(request);
    }

    // Don't trigger sync in this case and remove the header which was used to notify this interceptor
    if (request.headers.get('X-interceptor-nosync')) {
      request = request.clone({
        headers: request.headers.delete('X-interceptor-nosync')
      });

      return next.handle(request);
    }

    // Don't trigger in case of a non-relevant POST request (was blue band issue)
    const skipUrls = ['/statusinfo', '/timecards'];
    if (skipUrls.some(keyword => request.url.toLowerCase().includes(keyword))) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      tap(event => {
        // If the request was (most likely) successful, we can trigger sync
        if (event instanceof HttpResponse) {
          const pcId = request.headers.get('X-pcId');

          if (pcId != null) {
            const device = this.device.devices.find(dev => dev.id === pcId);

            if (device) {
              console.log('dev25_setNeedSync for request=' + request.urlWithParams);
              device.setNeedSync(true);
            }
          }
        }
      })
    );
  }
}
